import React, { useEffect, useMemo } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import usePermission from "../hooks/usePermission";
import Swal from "sweetalert2";

const PermissionRoute = ({ permission, children }) => {
 const { hasPermission, role } = usePermission();
 const navigate = useNavigate();

 const permissions = useMemo(
 () =>
 (Array.isArray(permission) ? permission : [permission]).filter(
 (item) => Boolean(item && String(item).trim())
 ),
 [permission]
 );

 const hasRoutePermission = permissions.some((item) => hasPermission(item));

 useEffect(() => {
 if (!role || permissions.length === 0 || hasRoutePermission) {
 return;
 }

 Swal.fire({
 title: "Restricted Access",
 text: "You currently don't have access to this feature. Please contact your administrator if access is required.",
 icon: "info",
 confirmButtonText: "OK",
 confirmButtonColor: "#3085d6",
 }).then(() => {
 if (window.history.length > 1) {
 navigate(-1);
 } else {
 navigate("/dashboard");
 }
 });
 }, [permissions.length, role, hasRoutePermission, navigate]);

 if (permissions.length === 0) {
 return children;
 }

 if (!role) {
 return <Navigate to="/" replace />;
 }

 if (!hasRoutePermission) {
 return null;
 }

 return children;
};

export default PermissionRoute;
